import { useState } from "react";
import { BarChart3, PieChartIcon } from "lucide-react";
import TrafficBarChart from "./TrafficBarChart";
import TrafficPieChart from "./TrafficPieChart";

// Define strict TypeScript types
type ChartType = "bar" | "pie";

interface TrafficData {
  total_sent: number;
  total_delivered: number;
  total_pending: number;
  total_failed: number;
  total_absent_from_network: number;
  invalid: number;
  total_delivered_to_network: number;
}

interface TrafficChartProps {
  trafficData: TrafficData;
}

const TrafficChart = ({ trafficData }: TrafficChartProps) => {
  const [activeChart, setActiveChart] = useState<ChartType>("bar");

  return (
    <>
      {/* Chart Selection */}
      <div className="flex space-x-3 mb-6">
        <button
          className={`inline-flex items-center rounded-lg px-4 py-2.5 text-sm font-medium transition-all ${
            activeChart === "bar"
              ? "bg-red-600 text-white shadow-md"
              : "bg-white text-gray-700 ring-1 ring-inset ring-gray-200 hover:bg-gray-50"
          }`}
          onClick={() => setActiveChart("bar")}
        >
          <BarChart3 className="mr-2 h-4 w-4" />
          Bar Chart
        </button>
        <button
          className={`inline-flex items-center rounded-lg px-4 py-2.5 text-sm font-medium transition-all ${
            activeChart === "pie"
              ? "bg-red-600 text-white shadow-md"
              : "bg-white text-gray-700 ring-1 ring-inset ring-gray-200 hover:bg-gray-50"
          }`}
          onClick={() => setActiveChart("pie")}
        >
          <PieChartIcon className="mr-2 h-4 w-4" />
          Pie Chart
        </button>
      </div>

      {/* Chart Components */}
      {activeChart === "bar" ? (
        <TrafficBarChart trafficData={trafficData} />
      ) : (
        <TrafficPieChart trafficData={trafficData} />
      )}
    </>
  );
};

export default TrafficChart;
